import { Interval, Currency } from '../types/product'

export * from './exercise';
export * from './constants';

export const capitalizeFirstLetter = s => `${s.charAt(0).toUpperCase()}${s.slice(1)}`;

export const uncapitalizeFirstLetter = s => `${s.charAt(0).toLowerCase()}${s.slice(1)}`;

// Generate unique IDs
export const ID = () => `_${Math.random().toString(36).substr(2, 9)}`;

export const getCurrencySymbol = (currency: Currency): string => ({
  usd: '$',
}[currency] || currency);

export const getIntervalABBR = (interval: Interval): string => ({
  day: 'd',
  month: 'mo',
  year: 'yr',
}[interval] || interval);

export const getIntervalDescription = (interval: Interval): string => ({
  day: 'Daily',
  month: 'Monthly',
  year: 'Yearly',
}[interval] || interval);
